const updateMoreCoverage = (state = {}, action) => {
    const { type = null, datasource, data = {} } = action;

    if (type === 'dataEngine_update_response') {
        if (datasource === 'contentGraph') {
            const { articles } = data || {};
            return { ...state, articles };
        }
        if (datasource === 'cmsdapi') {
            const { articles } = data;
            return { ...state, articles };
        }
    }

    return state;
};

export default updateMoreCoverage;
